<template>
  <Modal :hide-close="true" class="max-w-[500px]!">
    <StepModalHeader
      :title="flagged.title.value"
      :back="flagged.step.value !== 'match'"
      :centered="flagged.step.value !== 'details'"
      :busy="flagged.creating.value"
      @back="flagged.back"
      @close="close()"
    />
    <div class="mt-3.5">
      <FlaggedMatchBody variant="modal" :flagged="flagged" />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, useModal } from '@dacr/library'

import StepModalHeader from '../match/StepModalHeader.vue'
import FlaggedMatchBody from './FlaggedMatchBody.vue'
import { useFlaggedMatch, type FlaggedInfringement } from './useFlaggedMatch'

const props = defineProps<{ infringement: FlaggedInfringement }>()

const { close } = useModal()
const flagged = useFlaggedMatch(props.infringement)
</script>
